module.exports = "<app-video-tutorial *ngIf=\"tab === TutorialTypes.VIDEOS_TUTORIALS\"> </app-video-tutorial>\r\n<app-device-manual *ngIf=\"tab === TutorialTypes.DEVICE_MANUALS\"> </app-device-manual>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tutorial/tutorial-tab/tutorial-tab.component.html
// module id = ./src/app/shared/components/tutorial/tutorial-tab/tutorial-tab.component.html
// module chunks = main